// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__8Og8q","title":"InfoRow_title__3-HkF"};